export const IntroducerApiCapability = {
    PROPERTIES_WRITE: "properties:write",
    VALUATIONS_INSTANT: "valuations:instant",
    VALUATIONS_FULL: "valuations:full",
    CONVEYANCING_QUOTE: "conveyancing:quote",
    CONVEYANCING_INSTRUCT: "conveyancing:instruct",
} as const;

export const INTRODUCER_API_CAPABILITY_OPTIONS: Array<{ value: string; label: string }> = [
    { value: IntroducerApiCapability.PROPERTIES_WRITE, label: "Register properties" },
    { value: IntroducerApiCapability.VALUATIONS_INSTANT, label: "Instant valuations" },
    { value: IntroducerApiCapability.VALUATIONS_FULL, label: "Full valuations" },
    { value: IntroducerApiCapability.CONVEYANCING_QUOTE, label: "Conveyancing quotes" },
    { value: IntroducerApiCapability.CONVEYANCING_INSTRUCT, label: "Instruct conveyancing" },
];
